import { UserEstateTask } from '@/modules/estatetask/models/UserEstateTask';
import { EstateTaskUserStatus } from '@/modules/estatetask/enums/EstateTaskUserStatus';
import { EstateTaskFilterCollection } from '@/modules/estatetask/models/EstateTaskFilterCollection';

export class UserEstateTaskCollection extends EstateTaskFilterCollection<UserEstateTask> {
  constructor(items: UserEstateTask[] | UserEstateTaskCollection | undefined) {
    super(items, UserEstateTask);
  }

  static mapModel(
    items: UserEstateTask[] | UserEstateTaskCollection | undefined
  ): UserEstateTaskCollection {
    return new this(items);
  }

  get completedTasks(): UserEstateTask[] {
    return this.items?.filter((task: UserEstateTask) => task.isClosed) ?? [];
  }

  get incompleteTasks(): UserEstateTask[] {
    return this.items?.filter((task: UserEstateTask) => !task.isClosed) ?? [];
  }

  getActiveTasks(): UserEstateTaskCollection {
    return UserEstateTaskCollection.mapModel(
      this.items?.filter((task: UserEstateTask) => !task.isClosed) ?? []
    );
  }

  getOpenedTasks(): UserEstateTaskCollection {
    return UserEstateTaskCollection.mapModel(
      this.items?.filter((task: UserEstateTask) => !task.isClosed && !task.isCompleted) ?? []
    );
  }

  getGroupedEstateTasks(): Array<{ key: string | number; items: UserEstateTask[] }> {
    return this.hasItems
      ? this.getOpenedTasks()
          .groupBy((estateTask: UserEstateTask) => estateTask.status)
          .sort(
            (
              a: { key: string | number; items: UserEstateTask[] },
              b: { key: string | number; items: UserEstateTask[] }
            ): number => {
              if (a.key === EstateTaskUserStatus.TODO.key) {
                return -1;
              }

              if (b.key === EstateTaskUserStatus.TODO.key) {
                return 1;
              }

              return 0;
            }
          )
      : [];
  }
}
